import React from 'react';
import { format } from 'date-fns';
import SelectCheckbox from '../components/others/selectCheckbox';

const formatDateSafe = (value, pattern = 'dd/MM/yyyy') => {
    if (!value) return '';

    const date = new Date(value);

    if (isNaN(date.getTime())) return '';

    return format(date, pattern);
};

const columnsDevices = [
    {
        header: 'ID',
        accessorFn: row => row.id ? row.id : row.objectId
    },
    {
        header: 'Est supprimé',
        accessorKey: 'isDeleted',
    },
    {
        header: 'Nom',
        accessorKey: 'displayName',
        cell: ({row}) => { return row.original.id ? <a href={`https://portal.azure.com/#view/Microsoft_AAD_Devices/DeviceDetailsMenuBlade/~/Properties/objectId/${row.original.id}/deviceId/`} target='_blank' rel='noreferrer'>{row.original.displayName}</a> : <a href={`https://portal.azure.com/#view/Microsoft_AAD_Devices/DeviceDetailsMenuBlade/~/Properties/objectId/${row.original.objectId}/deviceId/`} target='_blank' rel='noreferrer'>{row.original.displayName}</a> }
    },
    {
        header: 'Utilisateur associé',
        accessorFn: row => Array.isArray(row.userId) ? row.userId[0].displayName : null
    },
    {
        header: 'Catégorie',
        accessorFn: row => row.deviceCategory ? row.deviceCategory : row.operatingSystem
    },
    {
        header: 'Enrollement',
        accessorKey: 'enrollmentType',
    },
    {
        header: 'Est managé',
        accessorKey: 'isManaged',
    },
    {
        header: 'Est conforme',
        accessorKey: 'isCompliant',
    },
    {
        header: 'Date de création',
        accessorKey: 'createdDateTime',
        cell: props => formatDateSafe(props.getValue()),
    },
    {
        header: '+',
        accessorKey: 'details',
        size: 50,
    }
];

const columnsGroups = [
    {
        header: 'ID',
        accessorFn: row => row.id ? row.id : row.objectId
    },
    {
        header: 'Est supprimé',
        accessorKey: 'isDeleted',
    },
    {
        header: 'Nom',
        accessorKey: 'displayName',
        cell: ({ row }) => {
            const { id, objectId, displayName, groupTypes } = row.original;
            const groupId = id || objectId;
            let url = "";

            const type = (groupTypes || "").toLowerCase();

            if (type.includes("groupe de sécurité") || type.includes("groupe de sécurité dynamique")) {
                url = `https://portal.azure.com/#view/Microsoft_AAD_IAM/GroupDetailsMenuBlade/~/Overview/groupId/${groupId}/menuId/`;
            }
            else if (type.includes("microsoft 365")) {
                url = `https://admin.exchange.microsoft.com/#/groups/:/GroupDetails/${groupId}/0`;
            }
            else if (type.includes("liste de distribution")) {
                url = `https://admin.exchange.microsoft.com/#/groups/:/GroupDetails/${groupId}/2`;
            }
            else if (type.includes("liste de distribution dynamique")) {
                url = `https://admin.exchange.microsoft.com/#/groups/:/GroupDetails/${groupId}/7`;
            }
            else if (type.includes("mail-enabled security")) {
                url = `https://admin.exchange.microsoft.com/#/groups/:/GroupDetails/${groupId}/3`;
            }
            else {
                url = `https://portal.azure.com/#view/Microsoft_AAD_IAM/GroupDetailsMenuBlade/~/Overview/groupId/${groupId}/menuId/`;
            }

            return (
                <a href={url} target="_blank" rel="noreferrer">
                    {displayName}
                </a>
            );
        },
        size: 300,
    },
    {
        header: 'Mail',
        accessorKey: 'mail',
    },
    {
        header: 'Alias',
        accessorFn: row => row.proxyAddresses,
        cell: props => props.getValue().map(address => <p key={address}>{address}</p>),
    },
    {
        header: 'Type',
        accessorKey: 'groupTypes',
    },
    {
        header: 'M365 : Public/Privé',
        accessorKey: 'visibility',
    },
    {
        header: 'Security Enabled',
        accessorKey: 'securityEnabled',
    },
    {
        header: 'Mail Enabled',
        accessorKey: 'mailEnabled',
    },
    {
        header: '+',
        accessorKey: 'details',
        size: 50,
    }
]

const columnsUsers = [
    {
        header: 'ID',
        accessorFn: row => row.id ? row.id : row.objectId
    },
    {
        header: 'Est supprimé',
        accessorKey: 'isDeleted',
    },
    {
        header: 'Nom complet',
        accessorKey: 'displayName',
        cell: ({row}) => { return row.original.id ? <a href={`https://portal.azure.com/#view/Microsoft_AAD_UsersAndTenants/UserProfileMenuBlade/~/overview/userId/${row.original.id}/hidePreviewBanner~/true`} target='_blank' rel='noreferrer'>{row.original.displayName}</a> : <a href={`https://portal.azure.com/#view/Microsoft_AAD_UsersAndTenants/UserProfileMenuBlade/~/overview/userId/${row.original.objectId}/hidePreviewBanner~/true`} target='_blank' rel='noreferrer'>{row.original.displayName}</a> }
    },
    {
        header: 'Prénom',
        accessorKey: 'givenName',
    },
    {
        header: 'Nom',
        accessorKey: 'surname',
    },
    {
        header: 'Trigramme',
        accessorKey: 'employeeId',
    },
    {
        header: 'UPN',
        accessorKey: 'userPrincipalName',
    },
    {
        header: 'Mail',
        accessorKey: 'mail',
    },
    {
        header: 'Alias',
        accessorKey: 'proxyAddresses',
        cell: props => props.getValue().map(address => <p key={address}>{address}</p>),
    },
    {
        header: 'Contrat',
        accessorKey: 'companyName',
    },
    {
        header: 'Etoile',
        accessorKey: 'department',
    },
    {
        header: 'Titre du poste',
        accessorKey: 'jobTitle',
    },
    {
        header: 'Mobile',
        accessorKey: 'mobilePhone',
    },
    {
        header: 'Ville',
        accessorKey: 'city',
    },
    {
        header: 'Code postal',
        accessorKey: 'postalCode',
    },
    {
        header: 'Adresse',
        accessorKey: 'streetAddress',
    },
    {
        header: 'Manager',
        accessorKey: 'manager',
    },
    {
        header: 'Compte activé',
        accessorKey: 'accountEnabled',
    },
    {
        header: '+',
        accessorKey: 'details',
        size: 50,
    }
]

// Affectations d'applications d'entreprise Entra ID : une ligne par couple
// (utilisateur, application). L'application n'est pas cliquable — le lien vers le
// portail Entra demande le couple (objectId du service principal, appId), et l'appId
// n'est pas collecté. L'utilisateur, lui, se déduit de principalId.
const columnsApplications = [
    {
        header: 'ID',
        accessorKey: 'objectId',
    },
    {
        header: 'Application',
        accessorKey: 'resourceDisplayName',
        size: 300,
    },
    {
        header: 'Principal affecté',
        accessorKey: 'principalDisplayName',
        cell: ({ row }) => {
            const { principalId, principalType, principalDisplayName } = row.original;
            const URLS = {
                User: `https://portal.azure.com/#view/Microsoft_AAD_UsersAndTenants/UserProfileMenuBlade/~/overview/userId/${principalId}/hidePreviewBanner~/true`,
                Group: `https://portal.azure.com/#view/Microsoft_AAD_IAM/GroupDetailsMenuBlade/~/Overview/groupId/${principalId}/menuId/`,
            };
            // ServicePrincipal : pas de lien, la fiche portail réclame l'appId de
            // l'application, que la collecte ne rapporte pas.
            const url = principalId ? URLS[principalType] : null;
            return url
                ? <a href={url} target='_blank' rel='noreferrer'>{principalDisplayName}</a>
                : principalDisplayName;
        },
        size: 260,
    },
    {
        header: 'Type',
        accessorKey: 'principalType',
        size: 100,
    },
    {
        // Nombre d'utilisateurs rattachés à l'affectation : 1 sur une ligne « User »,
        // la population héritée sur une ligne « Group ». Le tableau userId est
        // alimenté en $addToSet et jamais purgé, il surévalue donc les accès.
        header: 'Utilisateurs rattachés',
        accessorFn: row => (Array.isArray(row.userId) ? row.userId.filter(Boolean).length : 0),
    },
    {
        header: 'Rôle',
        accessorKey: 'appRoleId',
        // Le GUID nul signifie « accès par défaut » : l'application n'expose aucun rôle.
        cell: props => props.getValue() === '00000000-0000-0000-0000-000000000000'
            ? 'Accès par défaut'
            : props.getValue(),
    },
    {
        header: 'Affectée le',
        accessorKey: 'createdDateTime',
        cell: props => formatDateSafe(props.getValue()),
    },
    {
        // Une affectation retirée dans Entra est conservée et marquée : la colonne
        // reste vide tant que l'accès est en vigueur.
        header: 'Révoquée le',
        accessorKey: 'revokedAt',
        cell: props => formatDateSafe(props.getValue()),
    },
    {
        header: '+',
        accessorKey: 'details',
        size: 50,
    }
]

export function choiceColumns(value) {
    switch (value) {
        case 'Groups':
            return columnsGroups;
        case 'Devices':
            return columnsDevices;
        case 'Users':
            return columnsUsers;
        case 'Applications':
            return columnsApplications;
    }
}

// Mise en place des colonnes pour la partie Dashboard
// Base = displayName - UPN - Etoile

const detailColumn = {
    header: '+',
    accessorKey: 'details',
    size: 50,
}

export const base = [
    {
        id: 'select',
        header: ({ table }) => (
            <SelectCheckbox {
                ... {
                    checked: table.getIsAllRowsSelected(),
                    indeterminate: table.getIsSomeRowsSelected(),
                    onChange: table.getToggleAllRowsSelectedHandler(),
                }
            }
            />
        ),
        cell: ({ row }) => (
            <SelectCheckbox {
                ... {
                    checked: row.getIsSelected(),
                    disabled: !row.getCanSelect(),
                    indeterminate: row.getIsSomeSelected(),
                    onChange: row.getToggleSelectedHandler(),
                }
            }
            />
        ),
        size: 50
    },
    {
        header: 'Nom complet',
        accessorKey: 'displayName',
        cell: ({row}) => { return row.original.id ? <a href={`https://portal.azure.com/#view/Microsoft_AAD_UsersAndTenants/UserProfileMenuBlade/~/overview/userId/${row.original.id}/hidePreviewBanner~/true`} target='_blank' rel='noreferrer'>{row.original.displayName}</a> : <a href={`https://portal.azure.com/#view/Microsoft_AAD_UsersAndTenants/UserProfileMenuBlade/~/overview/userId/${row.original.objectId}/hidePreviewBanner~/true`} target='_blank' rel='noreferrer'>{row.original.displayName}</a> }
    },
    {
        header: 'UPN',
        accessorKey: 'userPrincipalName',
    },
    {
        header: 'Etoile',
        accessorKey: 'department',
    }
]

export const baseManager = [
    ...base,
    {
        header: 'Manager',
        accessorKey: 'manager',
    },
    {
        header: 'Statut',
        accessorKey: 'companyName',
    },
    detailColumn
]

export const baseCustomAttributes = [
    ...base,
    {
        header: 'CustomAttribute2',
        accessorKey: 'onPremisesExtensionAttributes.extensionAttribute2',
    },
    {
        header: 'CustomAttribute3',
        accessorKey: 'onPremisesExtensionAttributes.extensionAttribute3',
    },
    {
        header: 'CustomAttribute4',
        accessorKey: 'onPremisesExtensionAttributes.extensionAttribute4',
    },
    {
        header: 'Statut',
        accessorKey: 'companyName',
    },
    detailColumn
]

export const baseEmployeeId = [
    ...base,
    {
        header: 'EmployeeId',
        accessorKey: 'employeeId',
    },
    {
        header: 'Statut',
        accessorKey: 'companyName',
    },
    detailColumn
]

export const baseDetail = [
    ...base,
    {
        header: 'Statut',
        accessorKey: 'companyName',
    },
    detailColumn
]

export const baseLicense = [
    ...base,
    {
        header: 'Licenses',
        accessorKey: 'licenses'
    },
    {
        header: 'Statut',
        accessorKey: 'companyName',
    },
    detailColumn
]

export const baseDevice = [
    ...base,
    {
        header: 'Devices',
        accessorKey: 'devicesId',
        cell: props => props.getValue()?.map(devicesId => <p key={devicesId.displayName}>{`${devicesId.displayName} (${devicesId.operatingSystem} / ${devicesId.enrollmentType})`}</p>),
    },
    {
        header: 'Statut',
        accessorKey: 'companyName',
    },
    detailColumn
]

export const baseManagerDemandeur = [
    ...base,
    {
        header: 'Manager',
        accessorKey: 'manager',
    },
    {
        header: 'Demandeur',
        accessorKey: 'customSecurityAttributes.AttributesPrestataires.Demandeur',
    },
    detailColumn
]

export const baseOwnerGroup = [
    ...base,
    {
        header: 'Propriétaire groupe',
        accessorKey: 'groupsOwnerId',
        cell: props => props.getValue().map(groupsOwnerId => <p key={groupsOwnerId.displayName}>{groupsOwnerId.displayName}</p>),
    },
    detailColumn
]

export const baseGroup = [
    ...base,
    {
        header: 'Groupe',
        accessorKey: 'groupsId',
        cell: props => props.getValue().map(groupsId => <p key={groupsId.displayName}>{groupsId.displayName}</p>),
    },
    detailColumn
]